import react from 'react'
import { AppContext } from "../../App";
import { useContext } from "react";
import { Link } from 'react-router-dom';
import { NavLink } from "react-router-dom";
import { useState, useEffect } from "react";



// Import Css 
import './galerieTechComponent.css'

// Import Assets
import IconMarca1 from '../../assets/homeAssets/iconos-marcas/iconMarca1.svg';
import IconMarca2 from '../../assets/homeAssets/iconos-marcas/iconMarca2.svg';
import IconMarca3 from '../../assets/homeAssets/iconos-marcas/iconMarca3.svg';
import IconMarca4 from '../../assets/homeAssets/iconos-marcas/iconMarca4.svg';
import IconMarca5 from '../../assets/homeAssets/iconos-marcas/iconMarca5.svg';
import IconMarca6 from '../../assets/homeAssets/iconos-marcas/iconMarca6.svg';



export default function GallerieTechComponent ({ titleSectionTech, textInfoTech, valorProductTech, valorIndexBKGallerie, valorTitlePanel, valorTextInfoPanel }) {


//Use Context
const { bkGallerieTech, productTech } = useContext (AppContext)



const [indexBKGallerie, setIndexBKGallerie] = useState(valorIndexBKGallerie[0]);
const [indexTitlePanel, setIndexTitlePanel] = useState(valorTitlePanel[0]);
const [indexTextInfoPanel, setIndexTextInfoPanel] = useState(valorTextInfoPanel[0]);



// Lógica Rezise Gallerie Tech
const [isMobileGTech, setIsMobileGTech] = useState(window.innerWidth <= 460);

useEffect(() => {
  const handleResize = () => setIsMobileGTech(window.innerWidth <= 460);
  window.addEventListener('resize', handleResize);
  return () => window.removeEventListener('resize', handleResize);
}, []);


// Background Portada Tech
const bkGallerieTechMobile = window.innerWidth <= 460;
const bkGallerieTechComponent = {
    backgroundImage: `url(${bkGallerieTech[indexBKGallerie]})`, // Cambiado de 'backgroundImagen' a 'backgroundImage'
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    width: isMobileGTech ? '320px' : '380px',
    height: bkGallerieTechMobile ? '360px' : '320px',
};

console.log("bkGallerieTech:", bkGallerieTech);
console.log("indexBKGallerie:", indexBKGallerie);
console.log("Image URL:", bkGallerieTech[indexBKGallerie]);



    return(

    <div className="container-galerie-tech-component container-cctv">

        <div className="box-info-tech-section">

            <div className='box-info-tech'>

              <h2 className="title-info-tech-section">{titleSectionTech}</h2>
              <p className="text-info-tech-section">{textInfoTech}</p>

            </div>


            <p className='text-title-marcas'>Trabajamos con las mejores marcas del mercado</p>

            <div className="box-marcas-tech"> 

                <img className="logo-sect-tech logo-marca-tech-1" src={IconMarca1} alt="Marca x"/>
                <img className="logo-sect-tech logo-marca-tech-2" src={IconMarca2} alt="Marca y"/>
                <img className="logo-sect-tech logo-marca-tech-3" src={IconMarca3} alt="Marca z"/>
                <img className="logo-sect-tech logo-marca-tech-4" src={IconMarca4} alt="Marca x"/>
                <img className="logo-sect-tech logo-marca-tech-5" src={IconMarca5} alt="Marca y"/>
                <img className="logo-sect-tech logo-marca-tech-6" src={IconMarca6} alt="Marca z"/>

            </div>

        </div>


        <div className="box-galerie-tech galerie-tech-cctv" style={bkGallerieTechComponent}>

            <div className='box-boton-123'>

                {/* Botón No. 1 */}
               <button
                    className='boton-123 boton-1'
                    onClick={() => {
                        setIndexBKGallerie(valorIndexBKGallerie[0]);
                        setIndexTitlePanel(valorTitlePanel[0]);
                        setIndexTextInfoPanel(valorTextInfoPanel[0]);
                    }}> 1</button>

                {/* Botón No. 2 */}
                <button
                    className='boton-123 boton-1'
                    onClick={() => {
                        setIndexBKGallerie(valorIndexBKGallerie[1]);
                        setIndexTitlePanel(valorTitlePanel[1]);
                        setIndexTextInfoPanel(valorTextInfoPanel[1]);
                    }}> 2</button>

                {/* Botón No. 3 */}
                <button
                    className='boton-123 boton-1'
                    onClick={() => {
                        setIndexBKGallerie(valorIndexBKGallerie[2]);
                        setIndexTitlePanel(valorTitlePanel[2]);
                        setIndexTextInfoPanel(valorTextInfoPanel[2]);
                    }}> 3</button>

            </div>

            <div className='box-panel-info'>

                <h2 className='title-panel-info'>{valorTitlePanel? productTech[valorProductTech].titlePanel[indexTitlePanel]: 'No definido' }</h2>
                <p className='text-panel-info'>{valorTitlePanel? productTech[valorProductTech].textInfoPanel[indexTextInfoPanel]: 'No definido' }</p>

            </div>

        </div>

    </div> 
    /* //close tag */


    );
}